function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import Cookies from 'js-cookie';
import { VanillaTilt } from "vanilla-tilt";
import { toggle_loader, disable_loader } from './loader.js';
import Swiper, { Navigation, Pagination, Autoplay, Scrollbar } from 'swiper';
import { waitForTheElement } from 'wait-for-the-element';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
document.addEventListener('DOMContentLoaded', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var trap, evdb_swiper, evdb_swiper_gallery, debounce, bump_evdb_ui, custom_scrollbar_sliders, filter_sidebar, range_sliders, multiselect_inputs, order_dropdown, i, _i, evdb_swiper_gallery_resize_images, evdb_swiper_gallery_backdrop, evdb_related_swiper, animated_grid, _i4, closeEVToolTip, comparison_buttons, evdb_comparison_swiper, get_comparison_items, set_comparison_items, set_comparison_buttons, generate_comparison_ui, simple_banner;

  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          bump_evdb_ui = function _bump_evdb_ui() {
            var courtesy_bump = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var header = document.getElementsByTagName('header')[0];
            var footer = document.getElementsByTagName('footer')[0];
            var comparison_tool = document.getElementById('evdb-comparison-tool');
            var gallery_active = document.body.classList.contains('evdb-swiper-gallery');
            var scroll_offset = window.pageYOffset ? window.pageYOffset : 0;
            var footer_diff = false; //if we have a footer

            if (footer) {
              //calculate the difference between our current position and the footers position
              footer_diff = footer.getBoundingClientRect().bottom - (window.innerHeight + footer.offsetHeight); //if we have a footer diff and our comparison tool is visible

              if (footer_diff && comparison_tool) {
                //if we have a negative diff
                if (footer_diff < 0) {
                  //make the comparison tool follow the scroll
                  comparison_tool.style.bottom = footer_diff - footer_diff * 2 + 'px';
                } else {
                  //reset it
                  comparison_tool.style.bottom = '';
                }
              }
            } //our filter repositioning only needs to take place on 1280px and higher


            if (window.matchMedia('(min-width: 1280px)').matches) {
              var offset = header.offsetHeight + 70;
              var container = document.getElementById('evdb-filters-container');
              var filters = document.getElementById('evdb-filters');
              var banner = document.getElementById('notificationBanner'); //if we have a header and some filters

              if (header && filters) {
                //if we have a banner
                if (banner) {
                  var banner_offset = banner.offsetHeight - 20; //if this is before the banner has been scrolled past

                  if (scroll_offset < banner.offsetHeight) {
                    filters.parentElement.setAttribute('style', 'padding-top: ' + banner_offset + 'px');
                  } else if (scroll_offset >= banner.offsetHeight && scroll_offset < banner_offset) {
                    //otherwise it's been scrolled past but the header is still in view
                    filters.parentElement.setAttribute('style', 'padding-top: calc(' + banner_offset + 'px - ' + (banner_offset - scroll_offset + '').replace('-', '') + 'px)');
                  } else {
                    //otherwise it's gone, we don't need to mess with it any more
                    filters.parentElement.removeAttribute('style');
                  }
                }

                if (scroll_offset <= offset) {
                  filters.setAttribute('style', 'margin-top: -' + scroll_offset + 'px; max-height: calc(100vh + ' + scroll_offset + 'px);');
                } else if (!header.classList.contains('sticky-nav-active') && scroll_offset > 0.1) {
                  filters.setAttribute('style', 'margin-top: -' + offset + 'px; max-height: calc(100vh + ' + offset + 'px);');
                } else {
                  filters.removeAttribute('style');
                }
              } //if we have a footer diff


              if (footer_diff) {
                //wrapped in a try/catch due to an invalid style issue
                try {
                  //if we have a negative diff
                  if (footer_diff < 0) {
                    container.style.marginTop = footer_diff + 'px';
                  } else {
                    container.style.marginTop = '';
                  }
                } catch (e) {}
              }
            } //if the gallery is active and we have access to the evdb swiper


            if (gallery_active && evdb_swiper) {
              //calculate the bounding rect from the element
              var pos = evdb_swiper.el.parentElement.getBoundingClientRect(); //if the user is swiping away from the gallery

              if (document.documentElement.scrollTop > pos.top + evdb_swiper.el.offsetHeight) {
                //call our function to close the gallery
                evdb_swiper_gallery();
              }
            } //if we're doing a courtesy bump


            if (courtesy_bump) {
              //wait the specified number of ms, then bump
              setTimeout(function () {
                //recursively call us again
                bump_evdb_ui();
              }, courtesy_bump);
            }
          };

          //we can use this to persist our focus trap
          trap = false; //this will contain a reference to our evdb swiper if available

          evdb_swiper = false; //this will store our gallery function for easy access by the bump_ui watcher

          evdb_swiper_gallery = false; //require our debouncer library for listener events

          debounce = require('debounce'); //function called when scrolling in order to keep filters visible

          //get all elements using our custom scrollbar
          custom_scrollbar_sliders = document.getElementsByClassName('evdb-custom-scrollbar'); // if we have some slider elements

          if (custom_scrollbar_sliders && custom_scrollbar_sliders.length > 0) {
            (function () {
              //define our global variables
              var slider_down = false;
              var slider_x;
              var slider_left;
              var slider_timeout = false; //loop over our sliders

              var _loop = function _loop(i) {
                custom_scrollbar_sliders[i].addEventListener('click', function (e) {
                  //if the click is not allowed by the timeout
                  if (slider_timeout && slider_timeout > Math.floor(Date.now() / 1000)) {
                    //prevent the click
                    e.preventDefault();
                  }
                });
                custom_scrollbar_sliders[i].addEventListener('mousedown', function (e) {
                  slider_down = true;
                  custom_scrollbar_sliders[i].classList.add('active');
                  slider_x = e.pageX - custom_scrollbar_sliders[i].offsetLeft;
                  slider_left = custom_scrollbar_sliders[i].scrollLeft;
                });
                custom_scrollbar_sliders[i].addEventListener('mouseleave', function () {
                  slider_down = false;
                  custom_scrollbar_sliders[i].classList.remove('active');
                });
                custom_scrollbar_sliders[i].addEventListener('mouseup', function () {
                  slider_down = false;
                  custom_scrollbar_sliders[i].classList.remove('active');
                });
                custom_scrollbar_sliders[i].addEventListener('mousemove', function (e) {
                  if (slider_down) {
                    e.preventDefault();
                    custom_scrollbar_sliders[i].scrollLeft = slider_left - (e.pageX - custom_scrollbar_sliders[i].offsetLeft - slider_x) * 1.5; //set the timeout to be 1s from now

                    slider_timeout = Math.floor(Date.now() / 1000) + 1;
                  }
                });
              };

              for (var i = 0; i < custom_scrollbar_sliders.length; i++) {
                _loop(i);
              }
            })();
          } //if this is an EV archive page


          if (document.body.classList.contains('post-type-archive-electricvehicles')) {
            //get our filter sidebar
            filter_sidebar = document.getElementById('evdb-filters-container'); //fetch all range sliders on this page

            range_sliders = document.querySelectorAll('input[type="range"]'); //fetch all multiselect inputs on this page

            multiselect_inputs = document.querySelectorAll('.evdb-checkbox[data-name]'); //see if we have an orderby element

            order_dropdown = document.getElementById('evdb-orderby'); //if the document detects a click event

            document.addEventListener('click', function (event) {
              //if this is a click event for our filter toggles
              if (event.target.matches('.evdb-filter-toggle')) {
                //apply or remove the class to toggle them
                event.target.classList.toggle('evdb-filter-active');
              }

              if ((event.target.matches('#evdb-filter-toggle') || event.target.matches('#evdb-filter-close')) && filter_sidebar) {
                //if this is a click event for our sidebar toggle
                //require our focus trap library
                var focusTrap = require('focus-trap'); //initialize the trap on the sidebar if not already


                if (!trap) {
                  //initialize the trap
                  trap = focusTrap.createFocusTrap(filter_sidebar, {
                    fallbackFocus: document.getElementsByTagName('header')[0]
                  });
                } //if our filters aren't currently open


                if (!filter_sidebar.classList.contains('filter-prep')) {
                  //activate our trap
                  trap.activate(); //add our class to prepare our filter for movement

                  filter_sidebar.classList.add('filter-prep'); //wait 1ms to allow the class change to take place

                  setTimeout(function () {
                    //indicate the filter is properly open
                    filter_sidebar.classList.add('filter-open');
                  }, 1);
                } else {
                  //deactivate our trap
                  trap.deactivate(); //remove our open class

                  filter_sidebar.classList.remove('filter-open'); //wait 300ms for the transition to complete

                  setTimeout(function () {
                    //remove our class
                    filter_sidebar.classList.remove('filter-prep');
                  }, 300);
                }
              } //if this is a click event for our loader to toggle


              if (event.target.matches('.evdb-loader-toggle')) {
                //enable our loader
                toggle_loader();
              }
            }); //if we have some ranger sliders

            if (range_sliders && range_sliders.length > 0) {
              //loop over them
              for (i = 0; i < range_sliders.length; i++) {
                //add our change listener
                range_sliders[i].addEventListener('change', function (event) {
                  //attempt to find our target span tag to updat
                  var value_update = event.target.parentNode.querySelector('span'); //if we've found it

                  if (value_update) {
                    //update its value
                    value_update.innerHTML = event.target.value;
                  }
                });
              }
            } //if we have some multiselect inputs


            if (multiselect_inputs && multiselect_inputs.length > 0) {
              //loop over them
              for (_i = 0; _i < multiselect_inputs.length; _i++) {
                //add our change listener
                multiselect_inputs[_i].addEventListener('change', function (event) {
                  //get our multiselect field (combo)
                  var multiselect_field = document.querySelector('input[name="' + event.target.dataset.name + '"]'); //if we have access to the field pointed to by this input

                  if (multiselect_field) {
                    //fetch the current value for our field
                    var multiselect_value = multiselect_field.value; //if the value is currently empty

                    if (multiselect_value.length == 0) {
                      //add our value to it as the first element
                      multiselect_value = event.target.value;
                    } else {
                      //otherwise we have some other elements to deal with
                      //if this isn't a value representing 'any'
                      if (event.target.value != '') {
                        //if the value already includes this element, we want to remove it
                        if (multiselect_value.includes(event.target.value)) {
                          //remove our input from the element assuming it's part of a list
                          multiselect_value = multiselect_value.replace(event.target.value + ',', ''); //then remove again with just the name (if it's the only element)

                          multiselect_value = multiselect_value.replace(event.target.value, '');
                        } else {
                          //otherwise this is a new element and we need to add it alongside an already existing one
                          //add our value to the end
                          multiselect_value = multiselect_value + ',' + event.target.value;
                        }
                      } else {
                        //otherwise this is a selection for any
                        //blank out the multiselect value
                        multiselect_value = ''; //fetch a list of already selected options

                        var already_selected_options = document.querySelectorAll('input[data-name="' + event.target.dataset.name + '"]'); //if we have one or more options

                        if (already_selected_options && already_selected_options.length > 0) {
                          //loop over our selected options
                          for (var _i2 = 0; _i2 < already_selected_options.length; _i2++) {
                            //if this input doesn't represent 'any'
                            if (already_selected_options[_i2].value && already_selected_options[_i2].value != '') {
                              //uncheck it
                              already_selected_options[_i2].checked = false;
                            }
                          }
                        }
                      }
                    } //if for whatever reason we end up with a comma at the end


                    if (multiselect_value.slice(-1) == ',') {
                      //remove it
                      multiselect_value = multiselect_value.slice(0, -1);
                    } //save our updated value back


                    multiselect_field.value = multiselect_value;
                  } else {
                    console.warn('Unable to add this input to the selection');
                  }
                });
              }
            } //if we have an order dropdown


            if (order_dropdown) {
              //when the order is changed
              order_dropdown.addEventListener('change', function (event) {
                //identify the submit button
                var submit_button = order_dropdown.parentNode.nextElementSibling; //add a solid green border to indicate active status

                order_dropdown.classList.add('!border-green'); //if we have a button

                if (submit_button) {
                  //re-enable it
                  submit_button.classList.remove('hidden'); //set the rounding on the select dropdown to match

                  order_dropdown.classList.add('rounded-r-none');
                }
              });
            }
          } //if this is an EV child page


          if (document.body.classList.contains('single-electricvehicles')) {
            closeEVToolTip = function _closeEVToolTip(evt) {
              evt = evt || window.event;
              var isEscape = false;

              if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
              } else {
                isEscape = evt.key === 27;
              }

              if (isEscape) {
                var EVToolTip = document.querySelectorAll(".evdb-tile.evdb-tile-tooltip-active"),
                    _i5;

                for (_i5 = 0; _i5 < EVToolTip.length; ++_i5) {
                  EVToolTip[_i5].classList.remove("evdb-tile-tooltip-active");
                }
              }
            };

            evdb_swiper_gallery_backdrop = function _evdb_swiper_gallery_2() {
              //isolate our gallery styles
              var gallery_styles = document.getElementById('evdb-swiper-gallery-styles'); //if we have some gallery styles

              if (gallery_styles) {
                //fetch our active slide
                var active_slide = evdb_swiper.slides[evdb_swiper.activeIndex]; //set its image as our background blur

                gallery_styles.innerText = 'body.single-electricvehicles:before { background-image: url(' + active_slide.dataset.src + ') }';
              }
            };

            evdb_swiper_gallery_resize_images = function _evdb_swiper_gallery_() {
              //fetch all images that use the imagin CDN that have the default width of 400
              var images = document.querySelectorAll('.evdb-swiper .swiper-slide > img[src*="cdn.imagin.studio"][src*="width=400"]'); //if we have some images to correct

              if (images && images.length > 0) {
                //loop over them
                for (var _i3 = 0; _i3 < images.length; _i3++) {
                  //replace the width with a larger one
                  images[_i3].src = images[_i3].src.replace('width=400', 'width=1600');
                }
              }
            };

            evdb_swiper = new Swiper('.evdb-swiper', {
              modules: [Navigation, Autoplay],
              loop: true,
              navigation: {
                nextEl: ".evdb-swiper-button-next",
                prevEl: ".evdb-swiper-button-prev"
              }
            }); //defines a function that will open/close the gallery functionality

            evdb_swiper_gallery = function evdb_swiper_gallery() {
              //require our focus trap library
              var focusTrap = require('focus-trap'); //initialize the trap on the sidebar if not already


              if (!trap) {
                //initialize the trap
                trap = focusTrap.createFocusTrap(evdb_swiper.el.parentNode, {
                  fallbackFocus: document.getElementsByTagName('header')[0]
                });
              } //if the gallery is already open


              if (document.body.classList.contains('evdb-swiper-gallery')) {
                //remove the open gallery class, this causes it to shrink back down
                document.body.classList.remove('evdb-swiper-gallery'); //if we have a trap

                if (trap) {
                  //deactivate it
                  trap.deactivate(); //reset

                  trap = false;
                } //wait 300ms


                setTimeout(function () {
                  //remove the animating class, this allows the tile hover effect to work again
                  document.body.classList.remove('evdb-swiper-animating');
                }, 300);
              } else {
                //otherwise, we're opening the gallery
                var pos = evdb_swiper.el.parentNode.getBoundingClientRect(); //scroll to the top of the element

                window.scrollTo({
                  top: pos.top + document.documentElement.scrollTop - (window.matchMedia('(min-height: 768px)').matches ? 100 : 10),
                  behavior: "smooth"
                }); //if we have a trap

                if (trap) {
                  //activate it
                  trap.activate();
                } //resize our images (if using imagin)


                evdb_swiper_gallery_resize_images(); //trigger our backdrop to be added

                evdb_swiper_gallery_backdrop();
                setTimeout(function () {
                  //add both classes to allow size and block the tile hover effect
                  document.body.classList.add('evdb-swiper-gallery');
                  document.body.classList.add('evdb-swiper-animating');
                }, 100);
              }
            };

            evdb_swiper.on('activeIndexChange', evdb_swiper_gallery_backdrop);
            evdb_related_swiper = new Swiper('.related-evdb-swiper', {
              modules: [Navigation, Autoplay],
              slidesPerView: 1,
              spaceBetween: 10,
              breakpoints: {
                768: {
                  slidesPerView: 2,
                  spaceBetween: 10
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10
                },
                1280: {
                  slidesPerView: 4,
                  spaceBetween: 10
                }
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              }
            });
            animated_grid = document.getElementsByClassName('evdb-card-animate'); //if we have some animated grid elements

            if (animated_grid && animated_grid.length > 0) {
              //loop over the cards
              for (_i4 = 0; _i4 < animated_grid.length; _i4++) {
                //add our class to animate the card
                animated_grid[_i4].classList.add('evdb-card-animated'); //in 1s when the animation has completed


                setTimeout(function (elem) {
                  //remove our classes
                  elem.classList.remove('evdb-card-animate');
                  elem.classList.remove('evdb-card-animated');
                }, 1250, animated_grid[_i4]);
              }
            }

            document.addEventListener('keydown', closeEVToolTip, false);
            //if the document detects a click event
            document.addEventListener('click', function (event) {
              //if this is a click event for a detail card or the dedicated close button
              if (event.target.matches('.evdb-tile') || event.target.matches('.evdb-tile-tooltip-close')) {
                //get a list of all active cards
                var open_cards = document.getElementsByClassName('evdb-tile-tooltip-active'); //if the card is already toggled and it's the only open card

                if (event.target.matches('.evdb-tile') && event.target.classList.contains('evdb-tile-tooltip-active') && open_cards.length == 1) {
                  //remove the open class
                  event.target.classList.remove('evdb-tile-tooltip-active');
                } else {
                  //otherwise this is a new opening
                  //loop over active cards
                  for (var _i6 = 0; _i6 < open_cards.length; _i6++) {
                    //deactivate them
                    open_cards[_i6].classList.remove('evdb-tile-tooltip-active');
                  } //if this is a tile that's been clicked


                  if (event.target.matches('.evdb-tile')) {
                    //finally, activate our targeted card
                    event.target.classList.add('evdb-tile-tooltip-active');
                  }
                }
              } //if this is the gallery open/close button


              if (event.target.matches('.evdb-swiper-open') || event.target.matches('.evdb-swiper-close')) {
                //call our handler
                evdb_swiper_gallery();
              }
            });
          } //if this is an EV child page OR comparison page


          if (document.body.classList.contains('single-electricvehicles') || document.body.classList.contains('page-template-page-electricvehicles-comparison')) {
            //if the document detects a click event
            document.addEventListener('click', function (event) {
              //if this is a click for the accordion
              if (event.target.matches('.evdb-accordion-toggle')) {
                //get a list of all active accordions
                var open_accordions = document.getElementsByClassName('evdb-accordion-active'); //if the accordion is already toggled and it's the only open accordion OR it's the comparison page

                if (event.target.classList.contains('evdb-accordion-active') && (open_accordions.length == 1 || document.body.classList.contains('page-template-page-electricvehicles-comparison'))) {
                  //add our clicked button to an array of items to open
                  var accordions_to_close = [event.target]; //if this is the comparison page

                  if (document.body.classList.contains('page-template-page-electricvehicles-comparison')) {
                    //fetch all accordions that are open and work for this section
                    var additional_accordions = document.querySelectorAll('.evdb-accordion-toggle.evdb-accordion-active[data-section="' + event.target.dataset.section + '"]'); //if we have more than one accordion

                    if (additional_accordions && additional_accordions.length > 1) {
                      //swap the arrays around so we loop over these instead
                      accordions_to_close = additional_accordions;
                    }
                  } //loop over our the accordions we're going to open


                  var _loop2 = function _loop2(_i7) {
                    //save the target accordion here for easy reference
                    var accordion = accordions_to_close[_i7]; //set the size to its current size (auto -> 0px doesn't transition)

                    accordion.nextElementSibling.style.height = accordion.nextElementSibling.offsetHeight + 'px'; //wait for the above change to apply

                    setTimeout(function () {
                      //now we can set a 0px to transition to
                      accordion.nextElementSibling.style.height = '0px'; //wait for the transition

                      setTimeout(function () {
                        //restore the default sizing (auto)
                        accordion.nextElementSibling.style.height = ''; //remove the active class from the button

                        accordion.classList.remove('evdb-accordion-active'); //change aria-expanded to false

                        accordion.ariaExpanded = "false"; //remove the used class from our parent which returns each option to full opacity

                        accordion.parentNode.classList.remove('evdb-accordion-used');
                      }, 300);
                    }, 10);
                  };

                  for (var _i7 = 0; _i7 < accordions_to_close.length; _i7++) {
                    _loop2(_i7);
                  }
                } else {
                  //otherwise this is a new opening
                  //loop over active accordions
                  for (var _i8 = 0; _i8 < open_accordions.length; _i8++) {
                    //set the size to its current size (auto -> 0px doesn't transition)
                    open_accordions[_i8].nextElementSibling.style.height = open_accordions[_i8].nextElementSibling.offsetHeight + 'px'; //wait for the above change to apply

                    setTimeout(function (accordion) {
                      //now we can set a 0px to transition to
                      accordion.nextElementSibling.style.height = '0px'; //wait for the transition

                      setTimeout(function (accordion) {
                        //restore the default sizing (auto)
                        accordion.nextElementSibling.style.height = ''; //remove the active class from the button

                        accordion.classList.remove('evdb-accordion-active'); //change aria-expanded to false

                        accordion.ariaExpanded = "false";
                      }, 300, accordion);
                    }, 10, open_accordions[_i8]);
                  } //wrap this in a timeout to prevent jittering when closing and re-opening


                  setTimeout(function () {
                    //add our clicked button to an array of items to open
                    var accordions_to_open = [event.target]; //this will hold our target height (can change depending on if there's multiple accordions in play)

                    var resize_height = false; //fetch all accordions that work for this section

                    var additional_accordions = document.querySelectorAll('.evdb-accordion-toggle[data-section="' + event.target.dataset.section + '"]'); //if we have more than one accordion

                    if (additional_accordions && additional_accordions.length > 1) {
                      //swap the arrays around so we loop over these instead
                      accordions_to_open = additional_accordions;
                    } //loop over our the accordions we're going to open


                    for (var _i9 = 0; _i9 < accordions_to_open.length; _i9++) {
                      //save the target accordion here for easy reference
                      var accordion = accordions_to_open[_i9]; //set the active class

                      accordion.classList.add('evdb-accordion-active'); //change aria-expanded to true

                      accordion.ariaExpanded = "true"; //grab the height when auto takes over

                      var height = accordion.nextElementSibling.offsetHeight; //if we don't have an resize height or the resize height is smaller than what we have here

                      if (!resize_height || resize_height < height) {
                        //update the resize height
                        resize_height = height;
                      } //reset the height back to 0px


                      accordion.nextElementSibling.style.height = '0px'; //collect any description tags in the accordion (this means it's one with columns)

                      var description_tags = accordion.nextElementSibling.getElementsByClassName('stat-description'); //if we have some description tags to loop over

                      if (description_tags && description_tags.length > 0) {
                        var target_height = 0; //loop over them

                        for (var _i10 = 0; _i10 < description_tags.length; _i10++) {
                          //get the height of this tag
                          var tag_height = description_tags[_i10].offsetHeight; //if the tag height is larger than our target height

                          if (tag_height > target_height) {
                            //update it
                            target_height = tag_height;
                          }
                        } //if we have a target height


                        if (target_height) {
                          //loop over them again
                          for (var _i11 = 0; _i11 < description_tags.length; _i11++) {
                            //set the min height of this tag to the target
                            description_tags[_i11].style.minHeight = target_height + 'px';
                          }
                        }
                      }

                      accordion.scrollIntoView({
                        behavior: "smooth",
                        inline: "nearest"
                      }); //wait for the above change to apply

                      setTimeout(function (accordion) {
                        //set the height of the accordion to the size we know it should transition to
                        accordion.nextElementSibling.style.height = resize_height + 'px'; //wait for the transition

                        setTimeout(function (accordion) {
                          //reset the height again (let auto take over)
                          accordion.nextElementSibling.style.height = ''; //add the used class from our parent which fades out each other accordion

                          accordion.parentNode.classList.add('evdb-accordion-used');
                        }, 300, accordion);
                      }, 10, accordion); //if this is a breakpoint where our tables can sit side by side

                      if (window.matchMedia('(min-width: 1280px)').matches) {
                        //after the initial transition has completed
                        setTimeout(function (accordion) {
                          //set the height of the accordion again to account for any height changes from the others (if present)
                          accordion.nextElementSibling.style.height = resize_height + 'px';
                        }, 330, accordion);
                      }
                    }
                  }, open_accordions.length ? 400 : 0);
                } //if we have access to our UI bump function


                if (typeof bump_evdb_ui !== 'undefined') {
                  //wait for any animations to take place
                  setTimeout(function () {
                    //run our UI bump to make sure everything sits properly
                    bump_evdb_ui(300);
                  }, 300);
                }
              } else if (event.target.matches('.evdb-accordion-subtoggle')) {
                //if this is a sub-accordion
                //prevent native details opening
                event.preventDefault(); //if this is a single child page

                if (document.body.classList.contains('single-electricvehicles')) {
                  //bail, we don't want any of this running
                  return;
                } //get all instances of this accordion


                var sections = document.querySelectorAll('.evdb-accordion-toggle[data-section="' + event.target.dataset.section + '"]'); //get all details elements within those accordions

                var details = document.querySelectorAll('details[data-section="' + event.target.dataset.toggle + '"]'); //loop over all the details elements

                for (var _i12 = 0; _i12 < details.length; _i12++) {
                  //toggle it
                  details[_i12].open = !details[_i12].open;
                } //this will store our target height once we have it


                var adjusted_height = false; //loop over target sections

                for (var _i13 = 0; _i13 < sections.length; _i13++) {
                  //get the accordion content for this element
                  var accordion_content = sections[_i13].nextElementSibling; //reset the height

                  accordion_content.style.height = 'auto'; //get the height of the content

                  var calculated_height = accordion_content.offsetHeight; //if we don't have an adjusted height or the adjusted height is smaller than what we have here

                  if (!adjusted_height || adjusted_height < calculated_height) {
                    //update the adjusted height
                    adjusted_height = calculated_height;
                  }
                } //loop back over the sections again


                for (var _i14 = 0; _i14 < sections.length; _i14++) {
                  //set the height of the content
                  sections[_i14].nextElementSibling.style.height = adjusted_height + 'px';
                } //if we have access to our UI bump function


                if (typeof bump_evdb_ui !== 'undefined') {
                  //wait for any animations to take place
                  setTimeout(function () {
                    //run our UI bump to make sure everything sits properly
                    bump_evdb_ui(300);
                  }, 300);
                }
              }
            });
          } //fetch all comparison buttons on this page


          comparison_buttons = document.getElementsByClassName('comparison-toggle'); //if we have some comparison buttons OR this is the comparison page (we need all our code)

          if (comparison_buttons && comparison_buttons.length > 0 || document.body.classList.contains('page-template-page-electricvehicles-comparison')) {
            generate_comparison_ui = function _generate_comparison_() {
              var comparison = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

              //if we don't have comparison data, this means the function has run on page load
              if (!comparison) {
                //fetch our comparison items
                comparison = get_comparison_items();
              } //#region Handle creating the comparison tool
              //attempt to find the comparison tool on this page


              var comparison_tool = document.getElementById('evdb-comparison-tool'); //if we don't have any comparison items but the tool already exists

              if (comparison.length == 0 && comparison_tool) {
                //remove it, it's pointless for now
                comparison_tool.remove(); //remove our size adjusting body classes

                document.body.classList.remove('evdb-comparison-tool-visible');
                document.body.classList.remove('evdb-comparison-tool-open'); //ensure our UI sits where it should

                bump_evdb_ui();
              } else if (comparison.length > 0) {
                //if we have some items to compare
                //if the comparison tool doesn't already exist
                if (!comparison_tool) {
                  //build the basic elemment
                  comparison_tool = document.createElement('div');
                  comparison_tool.id = 'evdb-comparison-tool';
                  comparison_tool.className = 'fixed bottom-0 left-0 z-20 w-full -mb-px pointer-events-none 6xl:pl-0'; //if this is the archive page...

                  if (document.body.classList.contains('post-type-archive-electricvehicles')) {
                    //add padding left to account for the sidebar
                    comparison_tool.className = comparison_tool.className + ' xl:pl-[336px]';
                  } //append it to the body


                  document.body.appendChild(comparison_tool); //add a body class so we can account for the size this takes up

                  document.body.classList.add('evdb-comparison-tool-visible'); //re-fetch so the variable behaves the same

                  comparison_tool = document.getElementById('evdb-comparison-tool');
                } //this will become a UI of the cars we wish to compare


                var comparison_cards = ''; //determines whether or not we show the quick jump UI or the main comparison tray

                var quick_jump = document.body.classList.contains('page-template-page-electricvehicles-comparison'); //loop over our cars

                for (var _i18 = 0; _i18 < comparison.length; _i18++) {
                  //save here for reasier reference
                  var car = comparison[_i18]; //add the ui for this car

                  comparison_cards = comparison_cards + "<" + (quick_jump ? 'button type="button" data-id="' + car.id + '"' : 'div') + " class=\"" + (quick_jump ? 'evdb-comparison-quick-jump-toggle' : '') + " flex 2xl:block space-x-6 2xl:space-x-0\">\n\t\t\t\t\t" + (!quick_jump ? "<a href=\"" + (car.url ? car.url : '/find-vehicle') + "\">" : "") + "\n\t\t\t\t\t\t<img class=\"pointer-events-none border border-transparent rounded-lg 2xl:rounded-2.5xl bg-white " + (quick_jump ? 'w-auto' : 'w-[98px] 2xl:w-auto') + "\" src=\"" + car.image + "\" />\n\t\t\t\t\t" + (!quick_jump ? "</a>" : "") + "\n\n\t\t\t\t\t" + (!quick_jump ? "<div class=\"2xl:!mt-3 flex-1 2xl:flex-auto\">\n\t\t\t\t\t\t\t<p class=\"!my-0 text-white\">" + (car.make ? car.make + (car.model ? ' ' + car.model : '') : 'Unknown Vehicle') + "</p>\n\t\t\t\t\t\t\t<button class=\"text-pink text-sm comparison-toggle\" data-car=\"" + JSON.stringify(car).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;") + "\">\n\t\t\t\t\t\t\t\t<span class=\"icon-close mr-1 text-xs pointer-events-none\"></span>\n\t\t\t\t\t\t\t\tRemove\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>" : '') + "\n\t\t\t\t\t</" + (quick_jump ? 'button' : 'div') + ">";
                } //build up our UI


                var comparison_ui = "<div class=\"py-6 2xl:py-3 !px-8 2xl:!px-13 bg-greydark evdb-container mx-auto rounded-t-[20px] pointer-events-auto\">\n\t\t\t\t\t<div class=\"2xl:flex 2xl:space-x-16\">\n\t\t\t\t\t\t<div class=\"flex-1\">\n\t\t\t\t\t\t\t<button class=\"evdb-comparison-tool-toggle 2xl:translate-y-2.5 !text-white relative block w-full 2xl:w-auto text-left 2xl:inline-block pr-12\">\n\t\t\t\t\t\t\t\t" + (!quick_jump ? "Your car " + (comparison.length > 1 ? comparison.length + ' ' : '') + " comparison" + (comparison.length > 1 ? 's' : '') : 'Quick jump to car stats') + "\n\t\t\t\t\t\t\t\t<span class=\"icon-angle-right pointer-events-none bg-white w-8 h-8 rounded-full text-[8px] absolute top-1/2 right-0 -translate-y-1/2 text-greydark text-center leading-9\"></span>\n\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t" + (!quick_jump ? "<h6 class=\"text-white !text-[1.625rem] !mt-5 !mb-4 evdb-comparison-tool-hidden block 2xl:hidden\">\n\t\t\t\t\t\t\t\t" + (comparison.length > 1 ? 'Compare your ' + comparison.length + ' car choices' : 'Add another car to compare') + "\n\t\t\t\t\t\t\t</h6>" : '') + "\n\n\t\t\t\t\t\t\t<div class=\"evdb-comparison-tool-hidden grid " + (quick_jump ? 'grid-cols-4 mt-4' : 'grid-cols-1 sm:grid-cols-2 2xl:grid-cols-4') + " gap-2 gap-y-4 w-full pt-2 2xl:pt-10 pb-6 2xl:pb-3\">\n\t\t\t\t\t\t\t\t" + comparison_cards + "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t" + (!quick_jump ? "<div class=\"flex-initial 2xl:max-w-[280px] evdb-comparison-tool-hidden-2xl\">\n\t\t\t\t\t\t\t<h4 class=\"text-white !mt-16 !mb-7 evdb-comparison-tool-hidden hidden 2xl:block\">\n\t\t\t\t\t\t\t\t" + (comparison.length > 1 ? 'Compare your ' + comparison.length + ' car choices' : 'Add another car to compare') + "\n\t\t\t\t\t\t\t</h4>\n\n\t\t\t\t\t\t\t<a href=\"/find-vehicle/compare\" class=\"btn !px-15 w-full !font-normal flex-1" + (comparison.length == 1 ? ' !opacity-25 grayscale pointer-events-none' : '') + "\">\n\t\t\t\t\t\t\t\tCompare choices\n\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>" : '') + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>"; //set our inner HTML on the comparison UI

                comparison_tool.innerHTML = comparison_ui;
              } //#endregion
              //#region Handle creating and updating the comparison grid
              //attempt to fetch our comparison grid


              var comparison_grid = document.getElementById('evdb-comparison-grid'); //if we have access to the grid

              if (comparison_grid) {
                //toggle the loader (if it isn't already here)
                toggle_loader(); //create a new HTTP request instance

                var xhttp = new XMLHttpRequest(); //when the request changes state (e.g. start, end) this will trigger

                xhttp.onreadystatechange = function () {
                  if (this.status === 200) {
                    var grid_html = xhttp.responseText; //if we have something to display

                    if (grid_html) {
                      //assume we've hit with page with no vehicles
                      var vehicles_to_compare = 0; //if this comparison grid is for 1 vehicle

                      if (grid_html.includes('data-vehicles="1"')) {
                        //update our variable to match
                        vehicles_to_compare = 1;
                      } else if (grid_html.includes('data-vehicles="2"')) {
                        //if this comparison grid is for 2 vehicle
                        //update our variable to match
                        vehicles_to_compare = 2;
                      } else if (grid_html.includes('data-vehicles="3"')) {
                        //if this comparison grid is for 3 vehicle
                        //update our variable to match
                        vehicles_to_compare = 3;
                      } else if (grid_html.includes('data-vehicles="4"')) {
                        //if this comparison grid is for 4 vehicle
                        //update our variable to match
                        vehicles_to_compare = 4;
                      } //replace the grid HTML


                      comparison_grid.innerHTML = grid_html; //if we have a slider that already exists

                      if (evdb_comparison_swiper) {
                        //destroy the existing slider
                        evdb_comparison_swiper.destroy();
                      }

                      function apply_quick_jump_ui() {
                        //find our active slide
                        var slide = this.slides[this.activeIndex]; //if we have a slide element

                        if (slide) {
                          //fetch all quick jump toggles
                          var quick_jump_toggles = document.querySelectorAll('.evdb-comparison-quick-jump-toggle'); //if we have some quick jump toggles

                          if (quick_jump_toggles && quick_jump_toggles.length > 0) {
                            //loop over them
                            for (var _i19 = 0; _i19 < quick_jump_toggles.length; _i19++) {
                              //remove the active class if it's available
                              quick_jump_toggles[_i19].classList.remove('quick-jump-active'); //if this toggle matches the active slide


                              if (quick_jump_toggles[_i19].dataset.id === slide.dataset.id) {
                                //restore the activeclass
                                quick_jump_toggles[_i19].classList.add('quick-jump-active');
                              }
                            }
                          }
                        }
                      } //re-initialize the comparison slider


                      evdb_comparison_swiper = new Swiper('.evdb-car-comparison-container', {
                        init: false,
                        modules: [Scrollbar],
                        slidesPerView: vehicles_to_compare > 1 ? 2 : 1,
                        spaceBetween: 10,
                        breakpoints: {
                          640: {
                            slidesPerView: vehicles_to_compare > 2 ? 3 : 2
                          },
                          768: {
                            slidesPerView: vehicles_to_compare > 2 ? vehicles_to_compare > 3 ? 4 : 3 : 2
                          }
                        },
                        scrollbar: {
                          el: ".evdb-swiper-scrollbar",
                          hide: false,
                          draggable: true
                        },
                        on: {
                          init: apply_quick_jump_ui,
                          slideChange: apply_quick_jump_ui
                        }
                      });
                      evdb_comparison_swiper.init(); //disable the loader

                      disable_loader();
                    }
                  }
                }; //pull our endpoint from the grid element


                xhttp.open("GET", comparison_grid.getAttribute('data-endpoint') + '?vehicles=' + get_comparison_items(true), true); //initiate the request

                xhttp.send();
              } //#endregion
              //run our UI bump to make sure everything sits properly


              bump_evdb_ui();
            };

            set_comparison_buttons = function _set_comparison_butto() {
              var comparison = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

              //if we've been provided comparison data, this is from a chained function
              if (comparison) {
                //refresh our comparison buttons in case these have
                comparison_buttons = document.getElementsByClassName('comparison-toggle'); //loop over our comparison buttons on the page (we need to reset them)

                for (var _i17 = 0; _i17 < comparison_buttons.length; _i17++) {
                  //remove our active class
                  comparison_buttons[_i17].classList.remove('comparison-toggle-active');
                }
              } else {
                //if we don't have comparison data
                //get them fresh
                comparison = get_comparison_items();
              } //loop over the cars in our comparison data


              comparison.forEach(function (car) {
                //attempt to get the comparison button tied to this array
                var comparison_button = document.querySelector('.comparison-toggle[data-id="' + car.id + '"]'); //if the button is found on this page

                if (comparison_button) {
                  //add the active button class
                  comparison_button.classList.add('comparison-toggle-active');
                }
              });
            };

            set_comparison_items = function _set_comparison_items(new_car) {
              var comparison = get_comparison_items(); //let's assume the car we've been given doesn't already exist

              var exists = false; //loop over each car we have (if we have any at all!)

              for (var _i16 = 0; _i16 < comparison.length; _i16++) {
                var car = comparison[_i16]; //if we haven't already found this car in our comparison array

                if (!exists) {
                  //if we already have this car in the comparison tool
                  if (car.id === new_car.id) {
                    //set the flag as true
                    exists = true; //remove this item from the array

                    comparison.splice(_i16, _i16 == 0 ? 1 : _i16);
                  }
                }
              } //if after our search we're ok to proceed and we're not at max


              if (!exists && comparison.length <= 3) {
                //add our new car onto the comparison array
                comparison.push(new_car);
              } else if (!exists) {
                //otherwise if we're at max
                //alert
                alert("Max 4 cars");
              } //save our comparison options back to the cookie


              Cookies.set('me-evdb-comparison', JSON.stringify(comparison)), {
                expires: 1
              }; //apply the correct status to the buttons on this page

              set_comparison_buttons(comparison); //build the UI

              generate_comparison_ui(comparison);
            };

            get_comparison_items = function _get_comparison_items() {
              var url_ready = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              //attempt to fetch an existing comparison
              var comparison = Cookies.get('me-evdb-comparison'); //if we have a pre-existing comparison array

              if (comparison) {
                //decode it from JSON
                comparison = JSON.parse(comparison);
              } else {
                //otherwise if we don't have one already
                //create a blank array
                comparison = [];
              } //if this request is for comparison items that are ready to be added to our URL


              if (url_ready) {
                //this will hold our output
                var query_string = ''; //loop over our comparison items

                for (var _i15 = 0; _i15 < comparison.length; _i15++) {
                  //add our ID to the comparison string
                  query_string = query_string + ((_i15 != 0 ? ',' : '') + comparison[_i15].id);
                }

                return query_string;
              } //return our data


              return comparison;
            };

            //this will hold the comparison slider
            evdb_comparison_swiper = false;
            document.addEventListener('click', function (event) {
              //if the clicked element is our comparison toggle
              if (event.target.matches('.comparison-toggle')) {
                //prevent the a tag taking us to the child page
                event.preventDefault(); //fetch the data for this vehicle

                var data = JSON.parse(event.target.dataset.car); //if we have data and we at least have its ID

                if (data && data.id) {
                  //pass this to our comparison function to do its thing
                  set_comparison_items(data);
                }
              } //if the clicked element is our comparison tool toggle


              if (event.target.matches('.evdb-comparison-tool-toggle')) {
                //attempt to fetch our comparison tool
                var comparison_tool = document.getElementById('evdb-comparison-tool'); //if we have access the the comparison tool

                if (comparison_tool) {
                  //toggle an active status on it
                  comparison_tool.classList.toggle('comparison-tool-active');
                  document.body.classList.toggle('evdb-comparison-tool-open'); //ensure our UI sits where it should

                  bump_evdb_ui();
                }
              } //if the clicked element is our quick jump toggle


              if (event.target.matches('.evdb-comparison-quick-jump-toggle')) {
                //if we have access to a working comparison swiper
                if (evdb_comparison_swiper) {
                  //save our toggle to a variable for easier access
                  var toggle = event.target; //fetch all the comparison slides

                  var slides = evdb_comparison_swiper.slides; //loop over our slides

                  for (var _i20 = 0; _i20 < slides.length; _i20++) {
                    //if this slide matches the id of the toggle that's been clicked
                    if (slides[_i20].dataset.id === toggle.dataset.id) {
                      //jump to the target slide
                      evdb_comparison_swiper.slideTo(_i20);
                    }
                  }
                }
              }
            }, false); //call our functions to add the active class and generate the comparison UI (if applicable)

            set_comparison_buttons();
            generate_comparison_ui();
          }

          window.addEventListener('resize', debounce(bump_evdb_ui, 10));
          window.addEventListener('scroll', bump_evdb_ui); //run on load for good measure

          bump_evdb_ui(); //wait for simple banner to appear (if set)

          _context.next = 17;
          return waitForTheElement('#simple-banner', {
            timeout: 5000
          });

        case 17:
          simple_banner = _context.sent;

          //if we have a simple banner!
          if (simple_banner) {
            //bump the UI to account for it
            bump_evdb_ui();
          }

        case 19:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));